import LinearClearanceAssumptions from "./LinearClearanceAssumptions";

export default LinearClearanceAssumptions;
